module.exports = __webpack_public_path__ + "toBride1-we-w-g.1436b147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-w-g.jpg
// module id = l/Y9
// module chunks = 0